import { expected, isUndefined } from '@aloft/toolkit-shared';

import { useTkv2ReferenceBarUserInterface } from '../../../controller/hooks/useTkv2ReferenceBarUserInterface.ts';
import { selectReferenceBarUI } from '../../../redux/features/selectors/referenceBarUISelectors.ts';
import { useAppSelector } from '../../../redux/hooks.ts';
import { MapCoords, MapData } from '../hooks/useMapCoords.ts';
import { useCompSequence } from './useCompSequence.ts';

export const useActiveProperty = (mapData: MapCoords): MapData | undefined => {
  const { inPairedSales } = useTkv2ReferenceBarUserInterface();
  const { properties } = useAppSelector(selectReferenceBarUI);
  const compSequence = useCompSequence();

  // we only highlight the active property in paired cost, when we are mapping
  // comps.
  const firstProperty = properties && properties[0];
  const activeIndex = !inPairedSales ? +(firstProperty?.mapPinLabel || '') : undefined;

  if (mapData.isLoading || isUndefined(activeIndex) || isUndefined(compSequence)) return undefined;

  if (activeIndex === 0) {
    return mapData.results.subject;
  }
  const compId = compSequence[activeIndex - 1];
  return mapData.results[expected(compId)];
};
